<template>
    <div>
        <h2 class="hidden lg:block mt-8 mb-2 uppercase font-semibold text-base text-grey-dark">Chart Type</h2>
        <div class="py-4 lg:px-0 px-4 flex-row flex-wrap flex items-stretch">
            <a v-for="foo in chartTypes" class="pb-2 text-center flex flex-col justify-between mr-4 mb-4 bg-white cursor-pointer text-center w-24 border-2 border-white hover:bg-blue-lightest shadow rounded hover:border-blue-dark focus:outline-none"
               v-on:click="updateChart(foo)" :class="{'text-grey-darkest bg-blue-lightest border-blue-lighter': isActive(foo), 'text-grey-dark': !isActive(foo)}">
                <div>
                    <img class="h-16 w-24" :src="'/images/charts/' + foo.img">
                </div>
                <div class="text-sm">{{ foo.description }}</div>
            </a>
        </div>

        <div v-show="activeChart === 'scatter' || activeChart === 'variwide'">
            <div class="bg-purple">
                group by:
                <ul>
                    <li
                            v-for="dim in dimensions"
                            :class="{'text-white': dim.key === activeDim.group}"
                            @click="setGroup(dim.key)"
                    >
                        {{ dim.key }}
                    </li>
                </ul>

            </div>
            <div class="bg-green">
                x:
                <ul>
                    <li v-for="dim in dimensions" v-show="dim.key !== activeDim.group" class="">
                        <ul>
                            <li
                                    v-for="value in dim.values"
                                    :class="{'text-white': activeDim.x.key === dim.key && activeDim.x.value === value}"
                                    @click="setDimensionX(dim.key, value)"
                            >
                                {{ value }}
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="bg-blue">
                y:
                <ul>
                    <li v-for="dim in dimensions" v-show="dim.key !== activeDim.group">
                        <ul>
                            <li
                                    v-for="value in dim.values"
                                    :class="{'text-white': activeDim.y.key === dim.key && activeDim.y.value === value}"
                                    @click="setDimensionY(dim.key, value)"
                            >
                                {{ value }}
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</template>

<script>

    import store from "../store";

    export default {
        computed: {
            activeDim: function () {
                return this.$store.state.dimensions;
            },
            chartTypes: function () {
                return this.$store.state.chartTypesMotion;
            },
            dimensions: function () {
                return this.$store.getters.dimensions;
            },
            activeChart: function () {
                return this.$store.state.typeMotion;
            },
        },
        methods: {
            isActive(foo) {
                return foo.type === this.$store.state.typeMotion;
            },
            select(item) {
                this.active = item;
            },
            updateChart(foo) {
                this.$store.dispatch('updateChartMotion', foo);
            },
            setDimensionX(key, value) {
                this.$store.commit('setDimension', {
                    dimension: 'x',
                    key: key,
                    value: value,
                });
            },
            setDimensionY(key, value) {
                this.$store.commit('setDimension', {
                    dimension: 'y',
                    key: key,
                    value: value,
                });
            },
            setGroup(value) {
                this.$store.commit('setGroup', value);
            }
        },
    }

</script>